/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SaveClassModuleDisciplineViewModel } from "../types/SaveClassModuleDisciplineViewModel.ts";
import { eClassTypeSchema } from "./eClassTypeSchema.ts";
import { saveClassModuleRecurrenceViewModelSchema } from "./saveClassModuleRecurrenceViewModelSchema.ts";

export const saveClassModuleDisciplineViewModelSchema = z.object({
  disciplineId: z.optional(z.number().int()),
  classroomId: z.number().int().nullish(),
  teacherPersonId: z.number().int().nullish(),
  quantity: z.optional(z.number().int()),
  type: z.optional(
    z.lazy(() => eClassTypeSchema).describe("1 = Normal | 2 = OnDemand | "),
  ),
  planningWithExam: z.optional(z.boolean()),
  useMoveQA: z.optional(z.boolean()),
  isVisualizationAttendance: z.optional(z.boolean()),
  showOnStudentDocument: z.optional(z.boolean()),
  isIncludedInGradeCalculation: z.optional(z.boolean()),
  isIncludedInAttendanceCalculation: z.optional(z.boolean()),
  recurrences: z
    .array(z.lazy(() => saveClassModuleRecurrenceViewModelSchema))
    .nullish(),
}) as unknown as ToZod<SaveClassModuleDisciplineViewModel>;
